/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
export type AutoChatReplySettingExtraType =
  | 'BOOKING_REQUEST'
  | 'NONE'
  | 'QUESTION';

export type SettingsPageAutoChatReplyKeywordLinkSectionPanelAutoChatReplySettingFragment = { id: string, extra: { type: Types.AutoChatReplySettingExtraType, question: { selections: Array<{ text: string, link: { id: string } | null }> } | null } };

export const SettingsPageAutoChatReplyKeywordLinkSectionPanelAutoChatReplySettingFragmentDoc = gql`
    fragment SettingsPageAutoChatReplyKeywordLinkSectionPanelAutoChatReplySetting on AutoChatReplySetting {
  id
  extra {
    type
    question {
      selections {
        text
        link {
          id
        }
      }
    }
  }
}
    `;